var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 697,
    viewBox: "0 0 1920 697",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 697,
    fill: "url(#paint0_linear_35_1655)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_1655",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 697
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 697,
    fill: "url(#paint1_linear_35_1655)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_1655)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_d_35_1655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1472.66 304.976C1292.36 286.26 1265.12 442.679 1274.2 523.963C1297.36 653.757 1432.43 731.93 1486.04 759.569C1528.92 781.68 1622.15 872.226 1663.4 914.735C1826.68 1016.7 1882.73 824.822 1894 791.283C1905.27 757.743 1913.69 637.905 1980.25 546.878C2033.49 474.056 2059.84 395.186 2066.36 364.853C2080.21 228.671 2013.03 204.985 1983.73 195.178C1954.43 185.37 1888.86 189.908 1777.53 282.426C1688.46 356.441 1537.29 328.789 1472.66 304.976Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_d_35_1655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6613 272.976C-114.637 254.26 -141.883 410.679 -132.798 491.963C-109.64 621.757 25.4344 699.93 79.0386 727.569C121.922 749.68 215.15 840.226 256.403 882.735C419.679 984.704 475.731 792.822 487 759.283C498.268 725.743 506.695 605.905 573.25 514.878C626.494 442.056 652.844 363.186 659.363 332.853C673.211 196.671 606.032 172.985 576.732 163.178C547.432 153.37 481.865 157.908 370.531 250.426C281.463 324.441 130.287 296.789 65.6613 272.976Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter2_d_35_1655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1418.39 -27.6011C1187.07 -51.6131 1152.11 149.071 1163.77 253.359C1193.48 419.883 1366.78 520.179 1435.55 555.64C1490.57 584.008 1610.18 700.178 1663.11 754.717C1872.59 885.543 1944.51 639.36 1958.97 596.329C1973.42 553.298 1984.23 399.546 2069.62 282.759C2137.94 189.329 2171.74 88.1383 2180.11 49.2219C2197.87 -125.499 2111.68 -155.888 2074.09 -168.471C2036.5 -181.054 1952.38 -175.233 1809.54 -56.5321C1695.26 38.4284 1501.3 2.95129 1418.39 -27.6011Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35_1655",
    x: 1233.68,
    y: 156.572,
    width: 873.545,
    height: 830.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.733333 0 0 0 0 0.945098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35_1655"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35_1655",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_35_1655",
    x: -173.324,
    y: 124.572,
    width: 873.544,
    height: 830.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.733333 0 0 0 0 0.945098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35_1655"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35_1655",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_35_1655",
    x: 1122.81,
    y: -208.098,
    width: 1098.68,
    height: 1043.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.733333 0 0 0 0 0.945098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35_1655"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35_1655",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_1655",
    x1: 549.5,
    y1: -22.6834,
    x2: 1191.32,
    y2: 969.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86BBF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_1655",
    x1: 549.5,
    y1: -22.6834,
    x2: 1191.32,
    y2: 969.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86BBF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBg);
export default __webpack_public_path__ + "static/media/banner_bg.69d6dfde74885375aa8ffa2e0d60e08d.svg";
export { ForwardRef as ReactComponent };